// source: enums.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.cloud.ApplicationType', null, global);
goog.exportSymbol('proto.cloud.CloudProvider', null, global);
goog.exportSymbol('proto.cloud.DriveType', null, global);
goog.exportSymbol('proto.cloud.EntityClass', null, global);
goog.exportSymbol('proto.cloud.EntityDerivativeType', null, global);
goog.exportSymbol('proto.cloud.EntityType', null, global);
goog.exportSymbol('proto.cloud.EventsToNotifyOn', null, global);
goog.exportSymbol('proto.cloud.ExceptionClass', null, global);
goog.exportSymbol('proto.cloud.FolderType', null, global);
goog.exportSymbol('proto.cloud.InviteStatus', null, global);
goog.exportSymbol('proto.cloud.JobMemershipType', null, global);
goog.exportSymbol('proto.cloud.JobReportType', null, global);
goog.exportSymbol('proto.cloud.JobType', null, global);
goog.exportSymbol('proto.cloud.NotifyType', null, global);
goog.exportSymbol('proto.cloud.QuotaUtilizationEventType', null, global);
goog.exportSymbol('proto.cloud.QuotaUtilizationResultType', null, global);
goog.exportSymbol('proto.cloud.TaskPhase', null, global);
goog.exportSymbol('proto.cloud.TaskStatus', null, global);
goog.exportSymbol('proto.cloud.TaskType', null, global);
goog.exportSymbol('proto.cloud.VerificationStrategy', null, global);
goog.exportSymbol('proto.cloud.VolumeFolderType', null, global);
/**
 * @enum {number}
 */
proto.cloud.EntityType = {
  ENTITY_TYPE_INVALID: 0,
  ENTITY_TYPE_NON_SPECIFIC: 1,
  ENTITY_TYPE_VIDEO: 2,
  ENTITY_TYPE_AUDIO: 3,
  ENTITY_TYPE_IMAGE: 4,
  ENTITY_TYPE_REPORT: 5,
  ENTITY_TYPE_LUT: 6,
  ENTITY_TYPE_TAPE_INDEX: 7,
  ENTITY_TYPE_MHL_V2_GEN_FILE: 8,
  ENTITY_TYPE_MHL_V2_CHAIN_FILE: 9
};

/**
 * @enum {number}
 */
proto.cloud.EntityDerivativeType = {
  ENTITY_DERIVATIVE_NONE: 0,
  ENTITY_DERIVATIVE_VIDEO_CREATES_VIDEO: 1,
  ENTITY_DERIVATIVE_VIDEO_CREATES_AUDIO: 2,
  ENTITY_DERIVATIVE_VIDEO_CREATES_FRAME: 3,
  ENTITY_DERIVATIVE_VIDEO_CREATES_THUMB: 4,
  ENTITY_DERIVATIVE_LUT_CREATES_VIDEO: 5,
  ENTITY_DERIVATIVE_IMAGE_FRAME_CREATES_VIDEO: 6,
  ENTITY_DERIVATIVE_IMAGE_WATERMARK_CREATES_VIDEO: 7,
  ENTITY_DERIVATIVE_IMAGE_CREATES_IMAGE: 8,
  ENTITY_DERIVATIVE_IMAGE_WATERMARK_CREATES_IMAGE: 9,
  ENTITY_DERIVATIVE_AUDIO_CREATES_VIDEO: 10,
  ENTITY_DERIVATIVE_AUDIO_CREATES_AUDIO: 11,
  ENTITY_DERIVATIVE_MHL_CREATES_MHL: 12
};

/**
 * @enum {number}
 */
proto.cloud.EntityClass = {
  ENTITY_NO_CLASS: 0,
  ENTITY_FIRST_CLASS: 1,
  ENTITY_SECOND_CLASS: 2
};

/**
 * @enum {number}
 */
proto.cloud.JobType = {
  JOB_TYPE_NONE: 0,
  JOB_TYPE_CUSTOM: 1,
  JOB_TYPE_REPLICATION: 2,
  JOB_TYPE_TRANSCODE: 3,
  JOB_TYPE_UPLOAD: 4,
  JOB_TYPE_COMPARISON: 5,
  JOB_TYPE_REPORT: 6,
  JOB_TYPE_VIEW: 7,
  JOB_TYPE_SEARCH: 8,
  JOB_TYPE_MHL_VERIFY: 20,
  JOB_TYPE_ASCMHL_CREATE: 21,
  JOB_TYPE_ASCMHL_VERIFY: 23,
  JOB_TYPE_ASCMHL_DIFF: 25
};

/**
 * @enum {number}
 */
proto.cloud.JobMemershipType = {
  JOB_MEMBERSHIP_UNKNOWN: 0,
  JOB_MEMBERSHIP_FOLDER_TREE: 1,
  JOB_MEMBERSHIP_MEDIA_DERIVATIVE: 2,
  JOB_MEMBERSHIP_REPORT: 3
};

/**
 * @enum {number}
 */
proto.cloud.InviteStatus = {
  INVITE_STATUS_UNKNOWN: 0,
  INVITE_STATUS_PENDING: 1,
  INVITE_STATUS_ACCEPTED: 2,
  INVITE_STATUS_REJECTED: 3,
  INVITE_STATUS_REVOKED: 4
};

/**
 * @enum {number}
 */
proto.cloud.FolderType = {
  FOLDER_NORMAL: 0,
  FOLDER_ROOT_FOLDER: 1,
  FOLDER_ROOT_WRAPPER: 2
};

/**
 * @enum {number}
 */
proto.cloud.QuotaUtilizationEventType = {
  QUOTA_UTILIAZATION_EVENT_NONE: 0,
  QUOTA_UTILIAZATION_EVENT_SEAT: 1,
  QUOTA_UTILIAZATION_EVENT_STORAGE: 2,
  QUOTA_UTILIAZATION_EVENT_HQ: 3
};

/**
 * @enum {number}
 */
proto.cloud.QuotaUtilizationResultType = {
  QUOTA_UTILIAZATION_RESULT_NO_CHANGE: 0,
  QUOTA_UTILIAZATION_RESULT_INCREASED: 1,
  QUOTA_UTILIAZATION_RESULT_DECREASED: 2
};

/**
 * @enum {number}
 */
proto.cloud.ApplicationType = {
  APPLICATION_NONE: 0,
  APPLICATION_IMAGINE_HQ: 1,
  APPLICATION_SHOTPUT_PRO: 2,
  APPLICATION_MYLTO: 3
};

/**
 * @enum {number}
 */
proto.cloud.EventsToNotifyOn = {
  EVENT_NOTIFICATION_NONE: 0,
  EVENT_NOTIFICATION_JOB_INIT: 1,
  EVENT_NOTIFICATION_JOB_FINALIZE: 2
};

/**
 * @enum {number}
 */
proto.cloud.NotifyType = {
  NOTIFY_TYPE_NONE: 0,
  NOTIFY_TYPE_PUSH: 1,
  NOTIFY_TYPE_EMAIL: 2
};

/**
 * @enum {number}
 */
proto.cloud.DriveType = {
  DRIVE_UNKNOWN: 0,
  DRIVE_HDD: 1,
  DRIVE_SSD: 2,
  DRIVE_HHD: 3,
  DRIVE_LTO: 4,
  DRIVE_ODA: 5,
  DRIVE_NETWORK: 6
};

/**
 * @enum {number}
 */
proto.cloud.VolumeFolderType = {
  FOLDER_TYPE_UNKNOWN: 0,
  FOLDER_TYPE_SOURCE: 1,
  FOLDER_TYPE_DESTINATION: 2,
  FOLDER_TYPE_COMPARISON_TARGET: 3
};

/**
 * @enum {number}
 */
proto.cloud.TaskType = {
  TASK_NONE: 0,
  TASK_COPY: 1,
  TASK_VERIFY: 2,
  TASK_UPLOAD: 4,
  TASK_DOWNLOAD: 8,
  TASK_TRANSCODE: 16,
  TASK_THUMBNAIL: 32,
  TASK_METADATA: 64,
  TASK_COMPARE: 128,
  TASK_REPORT: 256,
  TASK_INDEX: 512,
  TASK_CHECKSUM: 1024,
  TASK_SEARCH: 2048
};

/**
 * @enum {number}
 */
proto.cloud.VerificationStrategy = {
  VERIFICATION_NONE: 0,
  VERIFICATION_FILE_CHECKSUM: 1,
  VERIFICATION_FILE_ATTRIBUTES: 2,
  VERIFICATION_MHL_V1: 4,
  VERIFICATION_MHL_V2: 8
};

/**
 * @enum {number}
 */
proto.cloud.CloudProvider = {
  CLOUD_PROVIDER_NONE: 0,
  CLOUD_PROVIDER_IMAGINE: 1,
  CLOUD_PROVIDER_FRAMEIO: 10
};

/**
 * @enum {number}
 */
proto.cloud.TaskPhase = {
  PHASE_NONE: 0,
  PHASE_WAITING: 1,
  PHASE_PAUSED: 2,
  PHASE_WORKING: 3,
  PHASE_DONE: 4,
  PHASE_CANCELED: 5
};

/**
 * @enum {number}
 */
proto.cloud.TaskStatus = {
  STATUS_NONE: 0,
  STATUS_NO_ERROR: 1,
  STATUS_RECOVERED: 2,
  STATUS_ERRORED: 3
};

/**
 * @enum {number}
 */
proto.cloud.JobReportType = {
  JOB_REPORT_NONE: 0,
  JOB_REPORT_PDF: 1,
  JOB_REPORT_TXT: 2,
  JOB_REPORT_CSV: 3,
  JOB_REPORT_MHL_V1: 4,
  JOB_REPORT_MHL_V2_GEN_FILE: 5,
  JOB_REPORT_MHL_V2_CHAIN_FILE: 6
};

/**
 * @enum {number}
 */
proto.cloud.ExceptionClass = {
  EXCEPTION_NONE: 0,
  EXCEPTION_MAC_GENERIC: 1,
  EXCEPTION_MAC_POSIX: 3,
  EXCEPTION_MAC_NSEXCEPTION: 4,
  EXCEPTION_WINDOWS_GENERIC: 5,
  EXCEPTION_CLOUD_GENERIC: 10
};

goog.object.extend(exports, proto.cloud);
